import React from 'react';
import { Stack, Typography } from '@mui/material';


const ClientDetails = ({ name, street_address, city, postal_code, phone, correspondence_email }) => (
  <Stack direction="row" spacing={6} justifyContent="center">
    <Stack direction="column" spacing={2}>
      <Typography variant="h5">Imię i nazwisko:</Typography>
      <Typography variant="h5">Numer telefonu:</Typography>
      <Typography variant="h5">E-mail do korespondencji:</Typography>
      <Typography variant="h5">Adres:</Typography>
    </Stack>
    <Stack direction="column" spacing={2}>
      <Typography sx={{ fontWeight: 'normal' }} variant="h5">{name}</Typography>
      <Typography sx={{ fontWeight: 'normal' }} variant="h5">{phone}</Typography>
      <Typography sx={{ fontWeight: 'normal' }} variant="h5">{correspondence_email}</Typography>
      <Typography sx={{ fontWeight: 'normal' }} variant="h5">{street_address}</Typography>
    </Stack>
  </Stack>
);

export default ClientDetails;
